import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { notBlank } from "../util/ext";

//-- Todo, get default creator logo
import defaultLogo from "../manager-panel/logo-menu-brand@2x.png";

const maxHeight = 75;

const useStyles = makeStyles(theme => ({
  logo: {
    maxHeight: maxHeight,
  },
}));

const CreatorHeaderLogo = () => {
  const auth = useSelector(state => state.auth);
  const classes = useStyles();

  const [logoUrl, setLogoUrl] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);

  useEffect(() => {
    if (notBlank(auth.currentOrganization)) {
      setLogoUrl(auth.currentOrganization.brandingLogoUrl);
      setOrganizationName(auth.currentOrganization.name);
    } else {
      setLogoUrl(defaultLogo);
      setOrganizationName("Creator Admin");
    }
  }, [auth.currentOrganization]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      maxHeight={maxHeight}
    >
      <img className={classes.logo} src={logoUrl} alt={organizationName} />
    </Box>
  );
};

export default CreatorHeaderLogo;
